const API = {
    BASE_URL: 'https://api-v3.authenticating.com',
    HERE_GEOCODE_URL: 'https://geocode.search.hereapi.com/v1/geocode',
};

const APPLICATION = {
    VERSION: process.env.REACT_APP_PORTAL_VERSION,
    URL: 'https://portal.authenticate.com',
    MEDALLION_LINK_URL: 'https://verify.authenticating.com',
};

const DEV_TOOLS = {
    logError: true,
};

const ANALYTICS = {
    GTM: {
        ID: 'GTM-5HXZLH7',
        ENABLED: true,
    },
    DATADOG: {
        RUM: {
            APPLICATION_ID: process.env.REACT_APP_DATADOG_RUM_APPLICATION_ID,
            CLIENT_TOKEN: process.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN,
            ENABLED: process.env.REACT_APP_DATADOG_RUM_ENABLED === 'true',
        },
    },
};

const PROPERTY_RENTALS = {
    HOSTFULLY: {
        CONNECT_URL:
            'https://platform.hostfully.com/api/auth/oauth/authorize?scope=FULL&grantType=REFRESH_TOKEN',
        PROPERTY_URL:
            'https://platform.hostfully.com/app/#/l/integrations%2Fdefault%2Fintegration.jsp?enumId=authenticate',
    },
    OWNERREZ: {
        CONNECT_URL: 'https://app.ownerrez.com/oauth/authorize?response_type=code',
    },
};

module.exports = {
    ENV: 'production',
    MIN_TOP_UP_AMOUNT: 100,
    API,
    DEV_TOOLS,
    ANALYTICS,
    APPLICATION,
    PROPERTY_RENTALS,
};
